module.exports = __webpack_public_path__ + "img/2003_S.a128c654.png";